"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SelectionControlLabel;
var _react = _interopRequireDefault(require("react"));
var _cls = _interopRequireDefault(require("@soluto-design/styles/cls"));
var _selectionControls = _interopRequireDefault(require("@soluto-design/styles/components/atoms/selection-controls"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SelectionControlLabel(_ref) {
  var id = _ref.id,
    label = _ref.label,
    description = _ref.description,
    variant = _ref.variant,
    classes = _ref.classes,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: id,
    className: (0, _cls["default"])(_selectionControls["default"]['label-wrapper'], !!variant && _selectionControls["default"]["label-wrapper-variant-".concat(variant)], classes === null || classes === void 0 ? void 0 : classes.wrapper, className)
  }, /*#__PURE__*/_react["default"].createElement("span", _extends({}, typeof label === 'string' ? {
    dangerouslySetInnerHTML: {
      __html: label
    }
  } : {
    children: label
  }, {
    className: (0, _cls["default"])(_selectionControls["default"].label, classes === null || classes === void 0 ? void 0 : classes.label)
  })), !!description && /*#__PURE__*/_react["default"].createElement("span", _extends({}, typeof description === 'string' ? {
    dangerouslySetInnerHTML: {
      __html: description
    }
  } : {
    children: description
  }, {
    className: (0, _cls["default"])(_selectionControls["default"].description, classes === null || classes === void 0 ? void 0 : classes.description)
  })));
}
module.exports = exports.default;